module.exports = __webpack_public_path__ + "img/emoji-sad-on.9f9f964e.svg";